import { MULTI_SHOP_ENABLED, getEnvShopId } from '@core/config/shops';
import type { CartItem } from '@features/cart/types';
import { isGlobalProductId, parseGlobalProductId } from '@core/utils/globalIds';

export function resolveLineShopId(item: CartItem): string {
  if (item.shopId) return item.shopId;
  return getEnvShopId();
}

/** Distinct shop UUIDs for cart lines (order not preserved). */
export function uniqueCartShopIds(items: CartItem[]): string[] {
  return [...new Set(items.map((item) => resolveLineShopId(item)))];
}

/** @deprecated Use `resolveLineShopId`. */
export const resolveLineSourceKey = resolveLineShopId;

/** UUID used in Hasura for stock / booked_products. */
export function resolveLocalProductId(productId: string): string {
  if (MULTI_SHOP_ENABLED && isGlobalProductId(productId)) {
    return parseGlobalProductId(productId)?.localProductId ?? productId;
  }
  return productId;
}
